module.exports = __webpack_public_path__ + "img/linkedin.e034f30.png";